import React from 'react';
import Button from '../components/Button';

const Testimonials = () => {
    return (
        <>
            {/* Hero Section */}
            <section className="hero" style={{ minHeight: '60vh' }}>
                <div className="hero-content">
                    <h1 className="hero-title">Student Testimonials</h1>
                    <p className="hero-subtitle">Hear From Our Silambam Warriors</p>
                </div>
            </section>

            {/* Testimonials Section */}
            <section className="section section-dark">
                <div className="section-header">
                    <h2 className="section-title">What Our Students Say</h2>
                </div>

                <div className="cards-grid" style={{ gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))' }}>
                    <div className="testimonial-card">
                        <p className="testimonial-text">
                            "Learning Silambam online has been an incredible journey. The training is intense, authentic, and the cultural connection is profound. I've not only gained physical skills but also a deep appreciation for Tamil heritage."
                        </p>
                        <p className="testimonial-author">Raj Kumar</p>
                        <p className="testimonial-role">Intermediate Student - Mumbai, India</p>
                    </div>

                    <div className="testimonial-card">
                        <p className="testimonial-text">
                            "I started as a complete beginner and now I can perform advanced staff techniques. The structured curriculum is excellent and the instructor is patient and knowledgeable. Highly recommended!"
                        </p>
                        <p className="testimonial-author">Priya Devi</p>
                        <p className="testimonial-role">Regular Student - Chennai, India</p>
                    </div>

                    <div className="testimonial-card">
                        <p className="testimonial-text">
                            "The fitness transformation has been amazing. Silambam is the most complete workout I've ever experienced. It's challenging but incredibly rewarding. The community support is fantastic!"
                        </p>
                        <p className="testimonial-author">Pavithra</p>
                        <p className="testimonial-role">Regular Student - Chennai, India</p>
                    </div>

                    <div className="testimonial-card">
                        <p className="testimonial-text">
                            "As a working professional, the flexible online classes fit perfectly into my schedule. The recorded sessions mean I never miss a lesson. This is the future of martial arts training!"
                        </p>
                        <p className="testimonial-author">Logesh</p>
                        <p className="testimonial-role">Beginner Student - Tenkasi,India</p>
                    </div>

                    <div className="testimonial-card">
                        <p className="testimonial-text">
                            "I've trained in multiple martial arts, but Silambam stands out for its unique weapons and fluid movements. The instructor's expertise and passion for the art are truly inspiring."
                        </p>
                        <p className="testimonial-author">Geetha</p>
                        <p className="testimonial-role">Regular Student - Singapore</p>
                    </div>

                    <div className="testimonial-card">
                        <p className="testimonial-text">
                            "My 12-year-old son loves the classes! It's improved his focus, discipline, and confidence. The instructor knows how to engage young students while teaching authentic techniques."
                        </p>
                        <p className="testimonial-author">Lakshmi</p>
                        <p className="testimonial-role">Parent - Bangalore, India</p>
                    </div>

                    <div className="testimonial-card">
                        <p className="testimonial-text">
                            "The certification I received has opened doors for me to teach Silambam in my community. The knowledge and skills I gained are invaluable. Thank you for preserving this ancient art!"
                        </p>
                        <p className="testimonial-author">Karthik Murugan</p>
                        <p className="testimonial-role">Regular Student - Coimbatore, India</p>
                    </div>

                    <div className="testimonial-card">
                        <p className="testimonial-text">
                            "As a fitness enthusiast, I was looking for something different. Silambam exceeded all expectations. The full-body workout combined with mental discipline is exactly what I needed."
                        </p>
                        <p className="testimonial-author">Akshaya</p>
                        <p className="testimonial-role">Regular Student - Madurai, India</p>
                    </div>

                    <div className="testimonial-card">
                        <p className="testimonial-text">
                            "The Surul Vaal training is phenomenal! Learning to wield the flexible sword requires patience and practice, but the instructor's guidance makes it achievable. Absolutely loving it!"
                        </p>
                        <p className="testimonial-author">Vikram</p>
                        <p className="testimonial-role">Regular Student - Hyderabad, India</p>
                    </div>
                </div>
            </section>

            {/* CTA Section */}
            <section className="section section-gradient" style={{ textAlign: 'center', padding: '5rem 2rem' }}>
                <h2 style={{ fontSize: '3rem', marginBottom: '1.5rem' }}>Join Our Growing Community</h2>
                <p style={{ fontSize: '1.3rem', marginBottom: '2rem', color: 'var(--color-gold-light)' }}>
                    Become part of a global family of Silambam practitioners.
                </p>
                <div className="btn-group">
                    <Button to="/registration" style={{ fontSize: '1.2rem', padding: '1.2rem 3rem' }}>Start Your Journey</Button>
                    <Button to="/courses" variant="secondary" style={{ fontSize: '1.2rem', padding: '1.2rem 3rem' }}>View Courses</Button>
                </div>
            </section>
        </>
    );
};

export default Testimonials;
